<div *ngIf="isVisible" class="popup__wrapper">
  <div class="backdrop" (click)="onClose_click()"></div>
  <div class="popup">
    <div class="onboard" (click)="arrowLeft_click()">
      <ion-slides #slider pager="true">
        <ion-slide *ngFor="let item of notifications">
          <div class="popup-container" [class.isLink]="item.data_linkUrl != null && item.data_button == null" (click)="onBanner_click(item.data_linkUrl, item.data_linkUrl != null && item.data_button == null)">
            <div class="close_icon">
              <ion-icon name="close-outline" (click)="onClose_click()"></ion-icon>
            </div>
              <h1 *ngIf="item.data_title">{{ item.title }}</h1>
            <img *ngIf="item.data_imageUrl" [src]="item.data_imageUrl">
            <p *ngIf="item.imageUrl">{{item.data_body}}</p>
            <ion-button *ngIf="item.data_button" (click)="onButton_click(item.data_linkUrl)">{{ item.data_button }}</ion-button>
          </div>
        </ion-slide>
      </ion-slides>

    </div>
  </div>
</div>
